"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleReverseMapping = exports.ModuleKeyword = exports.ModuleMapping = exports.Module = void 0;
var Module;
(function (Module) {
    Module[Module["Admin"] = 1] = "Admin";
    Module[Module["Arrears"] = 2] = "Arrears";
    Module[Module["Claim"] = 3] = "Claim";
    Module[Module["Default"] = 4] = "Default";
    Module[Module["PiFileShare"] = 5] = "PiFileShare";
    Module[Module["PiPurposeTest"] = 6] = "PiPurposeTest";
    Module[Module["PiRequest"] = 7] = "PiRequest";
})(Module = exports.Module || (exports.Module = {}));
exports.ModuleMapping = {
    admin: Module.Admin,
    arrears: Module.Arrears,
    claim: Module.Claim,
    default: Module.Default,
    piFileShare: Module.PiFileShare,
    piPurposeTest: Module.PiPurposeTest,
    piRequest: Module.PiRequest,
};
var ModuleKeyword;
(function (ModuleKeyword) {
    ModuleKeyword["Admin"] = "admin";
    ModuleKeyword["Arrears"] = "arrears";
    ModuleKeyword["Claim"] = "claim";
    ModuleKeyword["Default"] = "default";
    ModuleKeyword["PiFileShare"] = "piFileShare";
    ModuleKeyword["PiPurposeTest"] = "piPurposeTest";
    ModuleKeyword["PiRequest"] = "piRequest";
})(ModuleKeyword = exports.ModuleKeyword || (exports.ModuleKeyword = {}));
exports.ModuleReverseMapping = (_a = {},
    _a[Module.Admin] = ModuleKeyword.Admin,
    _a[Module.Arrears] = ModuleKeyword.Arrears,
    _a[Module.Claim] = ModuleKeyword.Claim,
    _a[Module.Default] = ModuleKeyword.Default,
    _a[Module.PiFileShare] = ModuleKeyword.PiFileShare,
    _a[Module.PiPurposeTest] = ModuleKeyword.PiPurposeTest,
    _a[Module.PiRequest] = ModuleKeyword.PiRequest,
    _a);
